module.exports = __webpack_public_path__ + "static/img/card_info.d83b8c40.png";